import React from "react";
import "../../styles/Accordion.css"
import AllertIscrizione from "../multitessere/AllertIscrizione";

function SpaAccordionPrezzi() {
    return (
        <div className="accordion d-flex flex-column m-auto" id="accordionFlushExample" style={{maxWidth: "50em"}}>
            <div className="accordion-item">
                <h2 className="accordion-header d-flex flex-row" id="headingOne"
                    style={{justifyContent: "center", textAlign: "center"}}>
                    <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                            data-bs-target="#collapseOne" aria-expanded="false" aria-controls="collapseOne">
                        PREZZI
                    </button>
                </h2>
                <div id="collapseOne" className="accordion-collapse collapse" aria-labelledby="headingOne"
                     data-bs-parent="#accordionFlushExample">
                    <div className="accordion-body">
                        <div className="table-container">
                            <table className="table text-center m-auto" style={{width: "20em"}}>
                                <tbody>
                                <tr style={{backgroundColor: "#F8F8F8"}}>
                                    <th scope="row">Singolo</th>
                                    <td>12 €</td>
                                </tr>
                                <tr>
                                    <th scope="row">10 ingressi</th>
                                    <td>95 €</td>
                                </tr>
                                <tr >
                                    <th scope="row">20 ingressi<br/> </th>
                                    <td>185 €</td>
                                </tr>
                                <tr>
                                    <th scope="row">Open</th>
                                    <td>500 €</td>
                                </tr>
                                </tbody>
                            </table>
                        </div>
                        <br/>
                        <AllertIscrizione />
                    </div>
                </div>
            </div>
        </div>
    );
}

export default SpaAccordionPrezzi